<template>
<div class="editDraft mainContainer">
  <el-form :model="form" label-position="left" :rules="rules" ref="form" class="el-form" label-width="140px">
    <el-form-item label="项目内容" prop="intro">
      <el-input v-model="form.intro" type="textarea" placeholder="请输入项目内容"></el-input>
    </el-form-item>
    <el-form-item label="派活流程">
      <el-radio-group v-model="form.type" @change="changeType">
        <el-radio-button label="2">简易</el-radio-button>
        <el-radio-button label="1">招标</el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="地点">
      <el-input v-model="address" placeholder="请粘贴输入地址，可智能识别省份、城市信息" class="addressStyle"></el-input>
      <span class="shiBie" @click="identification" v-if="address">识别</span>
      <span class="btn_shibie_disable" v-else>识别</span>
      <div style="display: flex">
        <el-form-item prop="provinceCode">
          <el-select v-model="form.provinceCode" placeholder="请选择省份" @change="selectCities(1)" filterable>
            <el-option
              v-for="item in provinceList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="city">
          <el-select v-model="form.city" placeholder="请选择城市"  :disabled="!form.provinceCode" class="liu-cheng" filterable @change="form.address = ''">
            <el-option
              v-for="item in cityList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form-item>
    <el-form-item prop="address" class="search-listBox">
      <el-input v-model="form.address" placeholder="请输入详细地址" style="width: 500px" @input="keySearch"></el-input>
      <!--搜索列表-->
      <div class="search-list" v-show="!!form.address && search_list">
        <ul>
          <li v-for="(item, index) in search_list" :key="index" @click="onSearchLi(item)">
            <span class="name">{{ item.name }}</span>
            <div class="address">{{ item.address }}</div>
          </li>
          <li v-if="noSearchShow"><p>暂无搜索结果</p></li>
        </ul>
      </div>
    </el-form-item>
    <el-form-item label="派活对象">
      <el-checkbox-group v-model="objectsList">
        <el-checkbox-button v-for="item in assignWorkList" :label="item.id" :key="item.id" @change="selectAssignWork(item)">{{ item.name }}</el-checkbox-button>
      </el-checkbox-group>
    </el-form-item>
    <div v-show="form.type == 1">
      <el-form-item label="报名时间" required>
        <el-col :span="11">
          <el-form-item prop="signInBeginTime">
            <el-date-picker
              type="datetime"
              format="yyyy.MM.dd HH:mm"
              value-format="yyyy.MM.dd HH:mm"
              placeholder="请选择开始时间"
              v-model="form.signInBeginTime"
              @input="changeTravelTime(form.signInBeginTime, 'signInBeginTime')"
              style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col class="line" :span="1">-</el-col>
        <el-col :span="11">
          <el-form-item prop="signInEndTime">
            <el-date-picker
              type="datetime"
              format="yyyy.MM.dd HH:mm"
              value-format="yyyy.MM.dd HH:mm"
              placeholder="请选择结束时间"
              v-model="form.signInEndTime"
              @input="changeTravelTime(form.signInEndTime, 'signInEndTime')"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="投标截止时间" prop="tenderEndTime">
        <el-date-picker
          @input="changeTravelTime(form.tenderEndTime, 'tenderEndTime')"
          v-model="form.tenderEndTime"
          type="datetime"
          format="yyyy.MM.dd HH:mm"
          value-format="yyyy.MM.dd HH:mm"
          placeholder="请选择投标截止时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="开标时间" prop="bidOpeningTime">
        <el-date-picker
          @input="changeTravelTime(form.bidOpeningTime, 'bidOpeningTime')"
          v-model="form.bidOpeningTime"
          type="datetime"
          format="yyyy.MM.dd HH:mm"
          value-format="yyyy.MM.dd HH:mm"
          placeholder="请选择开标时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="项目计划完工时间">
        <el-date-picker
          @input="changeTravelTime(form.requiedFinishTime, 'requiedFinishTime')"
          v-model="form.requiedFinishTime"
          type="datetime"
          format="yyyy.MM.dd HH:mm"
          value-format="yyyy.MM.dd HH:mm"
          placeholder="请选择项目计划完工时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="投标人范围">
        <el-radio-group v-model="form.companyRange" @change="selectCompanyRange">
          <el-radio-button label="1">所有人员</el-radio-button>
          <el-radio-button label="2">部分队伍</el-radio-button>
          <el-button type="text" v-if="form.companyRange !== '1'" class="selectCompanyRange" @click="selectCompanyRange('2')">点击查看</el-button>
        </el-radio-group>
      </el-form-item>
    </div>
    <div v-show="form.type != 1">
      <el-form-item label="有效期">
        <el-select v-model="form.validDays" placeholder="请选择有效期">
          <el-option
            v-for="item in validDaysList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="工种">
        <span v-for="(item, index) in gongZhongLabels" :key="index" class="gong-zhong">{{ item }}</span>
        <el-button type="text" @click="workTypesDialog = true">选择工种</el-button>
      </el-form-item>
      <el-form-item label="招工人数">
        <el-input v-model="form.requiedWorkerNum" placeholder="请输入招工人数"></el-input>
      </el-form-item>
    </div>
    <el-form-item label="附件">
      <el-upload
        ref="upload"
        action="#"
        class="avatar-uploader"
        :http-request="requestUpload"
        :show-file-list="false"
        :before-upload="beforeUploadList"
        :limit="3"
        :file-list="attachs"
        :on-exceed="exceedText"
      >
        <el-button type="text">上传附件</el-button>
      </el-upload>
      <div
        class="taskAffix"
        v-for="(item, index) in attachs"
        :key="index"
        @click="previewMethods(item.attachUrl)"
        @mousemove="attachDelete(index)"
        @mouseout="isDelete"
      >
        <img src="../../assets/img/public/icon_pdf.png" class="taskAffixIcon" v-if="item.fileType === 'pdf'">
        <img src="../../assets/img/public/icon_excel.png" class="taskAffixIcon" v-else-if="item.fileType ==='xls' || item.fileType ==='xlsx'">
        <img src="../../assets/img/public/icon_ppt.png" class="taskAffixIcon" v-else-if="item.fileType ==='ppt' || item.fileType ==='pptx'">
        <img src="../../assets/img/public/icon_txt.png" class="taskAffixIcon" v-else-if="item.fileType === 'txt'">
        <img src="../../assets/img/public/icon_word.png" class="taskAffixIcon" v-else-if="item.fileType ==='doc' || item.fileType === 'docx'">
        <img src="../../assets/img/public/icon_img.png" class="taskAffixIcon" v-else-if="item.fileType === 'jpg' || item.fileType === 'png'" >
        <img src="../../assets/img/public/icon_default.png" class="taskAffixIcon" v-else>
        {{ item.attachName }}
        <i class="el-icon-circle-close" v-show="attachDeleteIndex === index" @click.stop="beforeRemove(index)"></i>
      </div>
    </el-form-item>
    <el-form-item label="是否代发">
      <el-radio-group v-model="form.otherPub">
        <el-radio :label="0">否</el-radio>
        <el-radio :label="1">是</el-radio>
      </el-radio-group>
    </el-form-item>
    <div v-show="form.otherPub !== 0">
      <el-form-item label="联系人" prop="otherName" :rules="form.otherPub !== 0 ? rules.otherName : []">
        <el-input v-model="form.otherName" placeholder="请输入联系人名称" style="width: 500px"></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="otherMobile" :rules="form.otherPub !== 0 ? rules.otherMobile : []">
        <el-input v-model="form.otherMobile" placeholder="请输入联系方式" style="width: 500px"></el-input>
      </el-form-item>
    </div>
  </el-form>
  <div class="button">
    <el-button type="primary" @click="publishSubmit" class="btnHeight_40 btWith_120" :loading="loading">确认发布</el-button>
    <!--<el-button type="warning" @click="draftSubmit" class="btnHeight_40 btWith_120 mg_left_40">保存为草稿</el-button>-->
  </div>

  <!--工种弹窗-->
  <workTypes  v-if="workTypesDialog" @close="workTypesDialog = false" @workTypesValues="workTypesValues" @workTypesLabels="workTypesLabels" :List="gongZhongList"/>

  <!--投标人弹窗-->
  <companyRange v-if="companyRangeDialog" @close="companyRangeDialog = false" @companyValues="companyValues"  :List="companyList" :objectsList="objectsList"/>
</div>
</template>

<script>
import { getNormalInfo, getSimpleInfo, selectProvinceList, selectCitiesByProvinceId, projectPub, draftSave, stsOss, browseUrl } from '@api/public'
import { validDaysList, assignWorkList } from '@/utils/enumerates'
import workTypes from '@views/components/workTypes'
import companyRange from '@views/components/companyRange'
let OSS = require('ali-oss')
import AMap from 'AMap'
const validatePhone = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('联系方式不能为空'))
  } else if (!/^\d{11}$/.test(value)) {
    return callback(new Error('请输入有效的联系方式'))
  } else {
    callback()
  }
}
export default {
  name: 'editDraft',
  components: {
    workTypes,
    companyRange
  },
  data () {
    return {
      loading: false,
      id: '',
      validDaysList: validDaysList,
      assignWorkList: assignWorkList,
      workTypesDialog: false,
      companyRangeDialog: false,
      provinceList: [], // 省
      cityList: [], // 市
      objectsList: [0],
      form: {
        type: '2',
        provinceCode: '',
        city: '',
        validDays: '15',
        companyRange: '1',
        otherPub: 0
      },
      rules: {},
      gongZhongList: [],
      gongZhongLabels: [],
      companyList: [],
      isUpload: true,
      attachs: [],
      fileData: '',
      fileName: '',
      attachDeleteIndex: '',
      address: '',
      search_list: [], // 搜索结果列表
      noSearchShow: false // 无搜索结果提示，无搜索结果时会显示暂无搜索结果
    }
  },
  created () {
    this.id = this.$route.query.id
    this.selectProvinceList()
    if (this.$route.query.type == 1) {
      // 标准的
      this.getProjectPubInfo()
    } else {
      // 简易详情
      this.getSimpleInfo()
    }
    this.resetValidate()
  },
  methods: {
    changeTravelTime (val, property) {
      this.$set(this.form, property, val)
      this.$forceUpdate()
    },
    resetValidate () {
      if (this.form.type == 1) {
        this.rules = {
          intro: [
            { required: true, trigger: 'blur', message: '项目内容不能为空' },
            { max: 500, message: '内容要求在500个字之内' }
          ],
          tenderEndTime: [{ required: true, message: '请选择投标截止时间', trigger: 'change' }],
          signInBeginTime: [
            { required: true, trigger: 'change', message: '请选择报名开始时间' }
          ],
          signInEndTime: [
            { required: true, trigger: 'change', message: '请选择报名结束时间' }
          ],
          bidOpeningTime: [
            { required: true, trigger: 'change', message: '请选择开标时间' }
          ],
          otherName: [
            { required: true, trigger: 'blur', message: '联系人名称不能为空' }
          ],
          otherMobile: [
            { required: true, trigger: 'blur', validator: validatePhone, }
          ],
          provinceCode: [
            { required: true, trigger: 'change', message: '地点不能为空' }
          ],
          city: [
            { required: true, trigger: 'change', message: '地点不能为空' }
          ]
        }
      } else {
        this.rules = {
          intro: [
            { required: true, trigger: 'blur', message: '项目内容不能为空' },
            { max: 500, message: '内容要求在500个字之内' }
          ],
          otherName: [
            { required: true, trigger: 'blur', message: '联系人名称不能为空' }
          ],
          otherMobile: [
            { required: true, trigger: 'blur', validator: validatePhone, }
          ],
          provinceCode: [
            { required: true, trigger: 'change', message: '地点不能为空' }
          ],
          city: [
            { required: true, trigger: 'change', message: '地点不能为空' }
          ]
        }
      }
    },
    // 标准草稿详情
    getProjectPubInfo () {
      getNormalInfo({
        id: this.id
      }).then(res => {
        if (res.data.code === 200) {
          this.form = res.data.data
          let projectPubInfo = res.data.data
          this.$set(this.form, 'type', this.$route.query.type)
          this.form.signInBeginTime = projectPubInfo.signBeginTime
          this.form.signInEndTime = projectPubInfo.signEndTime
          this.form.tenderEndTime = projectPubInfo.tenderEndTime
          this.form.bidOpeningTime = projectPubInfo.bidOpenTime
          this.form.requiedFinishTime = projectPubInfo.finishTime
          this.form.city = projectPubInfo.cityCode
          if (projectPubInfo.companys) {
            projectPubInfo.companys.map(item => {
              this.companyList.push(item.id)
            })
          }
          if (projectPubInfo.objects === '全部' || projectPubInfo.objects === '') {
            this.objectsList = [0]
          } else {
            this.objectsList = projectPubInfo.objectIds
          }
          this.attachs = projectPubInfo.attachs
          this.selectCities()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 简易草稿详情
    getSimpleInfo () {
      getSimpleInfo({
        id: this.id
      }).then(res => {
        if (res.data.code === 200) {
          this.form = res.data.data
          let projectPubInfo = res.data.data
          this.$set(this.form, 'type', this.$route.query.type)
          this.form.city = projectPubInfo.cityCode
          this.form.requiedWorkerNum = projectPubInfo.workerNum
          if (projectPubInfo.objects === '全部' || projectPubInfo.objects === '') {
            this.objectsList = [0]
          } else {
            this.objectsList = projectPubInfo.objectIds
          }
          if (projectPubInfo.workTypes) {
            this.gongZhongList = projectPubInfo.workTypeIds
            this.gongZhongLabels = projectPubInfo.workTypes
          }
          this.attachs = projectPubInfo.attachs
          this.selectCities()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    changeType (data) {
      this.resetValidate()
      if (data === '1') {
        this.form.type = '1'
        this.$set(this.form, 'companyRange', '1')
        this.gongZhongList = []
        this.gongZhongLabels = []
      } else {
        this.form.signInBeginTime = null
        this.form.signInEndTime = null
        this.form.tenderEndTime = null
        this.form.bidOpeningTime = null
        this.form.requiedFinishTime = null
        this.form.type = '2'
        this.companyList = []
      }
      this.$nextTick(() => {
        this.$refs["form"].clearValidate()
      })
    },
    selectProvinceList () {
      selectProvinceList().then(res => {
        if (res.data.code === 200) {
          this.provinceList = res.data.data.provinces
          this.cityInit(res.data.data.provinces)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    cityInit (provinceList) {
      if (provinceList) {
        provinceList.forEach(item => {
          if (item.text === localStorage.getItem('province')) {
            this.form.provinceCode = item.id
            this.form.city = localStorage.getItem('cityCode')
          }
        })
        this.selectCities()
      }
    },
    selectCities (type) {
      this.cityList = []
      if (type) {
        this.form.city = ''
      }
      selectCitiesByProvinceId({
        provinceId: this.form.provinceCode
      }).then(res => {
        if (res.data.code === 200) {
          res.data.data.map(item => {
            if (item.type !== 1) {
              this.cityList.push(item)
            }
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    selectAssignWork (item) {
      if (item.id === 0) {
        this.objectsList = [0]
      } else {
        this.objectsList.map((val, index) => {
          if (val === 0) {
            this.objectsList.splice(index, 1)
          }
        })
        this.objectsList.push(item.id)
      }
    },
    workTypesValues (data) {
      this.gongZhongList = data
    },
    workTypesLabels (data) {
      this.gongZhongLabels = data
    },
    selectCompanyRange (data) {
      console.log(data)
      if (data === '2') {
        this.companyRangeDialog = true
      } else {
        this.companyList = []
      }
    },
    companyValues (data) {
      this.companyList = data
    },
    beforeUploadList (file) {
      this.fileName = this.fileNameInit('/project/bidding/', file.name)

      const isLt50M = file.size / 1024 / 1024 < 50
      const FileExt = file.name.replace(/.+\./, '')
      if (['jpg', 'png', 'txt', 'zip', 'rar', 'pdf', 'doc', 'docx', 'xlsx', 'jfif', 'jpeg'].indexOf(FileExt.toLowerCase()) === -1) {
        this.$message.warning('请上传后缀名为doc、docx、xls、ppt、pdf等常见文件格式！')
        this.isUpload = false
        return false
      } else if (!isLt50M) {
        this.$message.warning('上传文件大小不能超过50MB!')
        this.isUpload = false
        return false
      } else {
        this.fileData = file
      }
    },
    requestUpload () {
      if (this.isUpload === true) {
        stsOss().then(res => {
          if (res.data.code === 200) {
            const ossData = res.data.data
            let client = new OSS({
              region: 'oss-cn-shanghai',
              accessKeyId: ossData.accessKeyId,
              accessKeySecret: ossData.accessKeySecret,
              bucket: 'yiyong-pri',
              stsToken: ossData.stsToken,
              secure: true
            })
            if (client) {
              client.put(this.fileName, this.fileData).then(
                res => {
                  // 下面是如果对返回结果再进行处理，根据项目需要
                  if (res.res.status === 200) {
                    console.log(res)
                    this.$message.success('上传成功')
                    this.attachs.push({
                      attachName: this.fileNameUpdate(res.name),
                      attachUrl: res.url
                    })
                  } else {
                    this.$message.error('上传失败')
                  }
                }).catch(err => {
                console.log('err:', err)
              })
            }
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    previewMethods (url) {
      // 调用后端接口获取加密url
      browseUrl({
        url: url
      }).then(res => {
        if (res.data.code === 200) {
          window.open(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    beforeRemove (index) {
      this.attachs.splice(index, 1)
    },
    attachDelete (index) {
      this.attachDeleteIndex = index
    },
    isDelete () {
      this.attachDeleteIndex = null
    },
    exceedText () {
      this.$message.error('最多只能上传3个')
    },
    publishSubmit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          const data = {}
          if (this.form.type === '1') {
            if (this.companyList) {
              data.companyIds = this.companyList.join(',')
            }
            const signInBeginTime = new Date(this.form.signInBeginTime.replace(/-/g, '/')).getTime()
            const signInEndTime = new Date(this.form.signInEndTime.replace(/-/g, '/')).getTime()
            const tenderEndTime = new Date(this.form.tenderEndTime.replace(/-/g, '/')).getTime()
            const bidOpeningTime = new Date(this.form.bidOpeningTime.replace(/-/g, '/')).getTime()
            if (signInBeginTime >= signInEndTime) {
              this.$message.error('报名截止时间要大于报名开始时间')
              return false
            } else if (signInEndTime > tenderEndTime) {
              this.$message.error('投标截止时间要大于等于报名截止时间')
              return false
            } else if (tenderEndTime > bidOpeningTime) {
              this.$message.error('开标时间要大于等于投标截止时间')
              return false
            } else if (this.form.requiedFinishTime) {
              const requiedFinishTime = new Date(this.form.requiedFinishTime.replace(/-/g, '/')).getTime()
              if (bidOpeningTime > requiedFinishTime) {
                this.$message.error('项目计划完工时间要大于开标时间')
                return false
              }
            }
          }
          data.attachs = this.attachs
          data.projectDraftId = this.id
          data.project = this.form
          const objectsList = []
          for (var i = 0; i < this.objectsList.length; i++) {
            if (objectsList.indexOf(this.objectsList[i]) === -1) {
              objectsList.push(this.objectsList[i])
            }
          }
          data.objects = objectsList.join(',') // 派活对象
          data.workTypes = this.gongZhongList.join(',') // 工种
          this.loading = true
          projectPub(data).then(res => {
            if (res.data.code === 200) {
              this.$message.success('发布成功')
              this.$router.replace('/project')
              this.form = {}
              this.attachs = []
              this.loading = false
            } else {
              this.$message.error(res.data.msg)
              this.loading = false
            }
          })
        }
      })
    },
    draftSubmit () {
      const data = {}
      if (this.companyList) {
        data.companyIds = this.companyList.join(',')
      }
      data.attachs = this.attachs
      data.projectDraftId = this.id
      data.project = this.form
      const objectsList = []
      for (var i = 0; i < this.objectsList.length; i++) {
        if (objectsList.indexOf(this.objectsList[i]) === -1) {
          objectsList.push(this.objectsList[i])
        }
      }
      data.objects = objectsList.join(',') // 派活对象
      data.type = this.$route.query.type // 找活类型
      data.workTypes = this.gongZhongList.join(',') // 工种
      draftSave(data).then(res => {
        if (res.data.code === 200) {
          this.$message.success('保存成功')
          this.$router.replace('/project')
          this.form = {}
          this.attachs = []
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    identification () {
      const addressData = this.smartParse(this.address)
      const provinceCode = addressData.provinceCode ? addressData.provinceCode + '0000':''
      const cityCode = addressData.cityCode ? addressData.cityCode + '00':''
      const county = addressData.county ? addressData.county:''
      const street = addressData.street ? addressData.street:''
      const address = addressData.address ? addressData.address:''
      const addressDetail = county + street + address
      this.$set(this.form, "provinceCode", provinceCode)
      this.selectCities()
      this.$set(this.form, "city", cityCode)
      this.$set(this.form, "address", addressDetail)
      // this.address = ''
      this.addressChange()
      this.$nextTick(() => {
        this.$refs["form"].clearValidate()
      })
    },
    keySearch() {
      let provinceCodeText = ''
      this.provinceList.map(item => {
        if (item.id === this.form.provinceCode) {
          provinceCodeText = item.text
        }
      })
      let cityCodeText = ''
      this.cityList.map(item => {
        if (item.id === this.form.city) {
          cityCodeText = item.text
        }
      })
      const diZhi = provinceCodeText + cityCodeText + this.form.address
      AMap.service(["AMap.PlaceSearch"], () => {
        // 构造地点查询类
        var placeSearch = new AMap.PlaceSearch({
          type: '汽车服务|餐饮服务|购物服务|生活服务|体育休闲服务|医疗保健服务|住宿服务|风景名胜|商务住宅|政府机构及社会团体|科教文化服务|交通设施服务|金融保险服务|公司企业|地名地址信息', //  兴趣点类别
          pageSize: 20, //  单页显示结果条数
          pageIndex: 1, //  页码
          city: cityCodeText, //  兴趣点城市
          citylimit: true
        })
        // 关键字查询
        placeSearch.search(diZhi, (status, result) => {
          if (status === 'complete') {
            if (result.poiList.count === 0) {
              this.noSearchShow = true
            } else {
              this.search_list = result.poiList.pois// 将查询到的地点赋值
              this.noSearchShow = false
            }
          } else {
            this.search_list = []
            this.noSearchShow = true
          }
        })
      })
    },
    onSearchLi(item) {
      this.form.address = item.name
      this.form.lng = item.location.lng
      this.form.lat = item.location.lat
      this.search_list = []
    },
    addressChange () {
      let provinceCodeText = ''
      this.provinceList.map(item => {
        if (item.id === this.form.provinceCode) {
          provinceCodeText = item.text
        }
      })
      let cityCodeText = ''
      this.cityList.map(item => {
        if (item.id === this.form.city) {
          cityCodeText = item.text
        }
      })
      const diZhi = provinceCodeText + cityCodeText + this.form.address
      const that = this
      AMap.plugin('AMap.Geocoder', function() {
        var geocoder = new AMap.Geocoder();
        geocoder.getLocation(diZhi, function(status, result) {
          console.log(status, result)
          if (status === 'complete' && result.info === 'OK') {
            that.form.lng = result.geocodes[0].location.lng;
            that.form.lat = result.geocodes[0].location.lat;
          } else {
            console.log('定位失败！');
          }
        });
      });
    }
  }
}
</script>

<style  lang="scss">
.editDraft{
  padding-top: 34px;
  padding-bottom: 64px;
  .el-button--text{
    font-size: 16px;
  }
  .button{
   width: 280px;
    margin: 0 auto;
  }
  .addressStyle{
    width: 500px;
    margin-bottom: 16px;
  }
  .el-select>.el-input{
    width: 245px;
  }
  .shiBie{
    background: #0368C1;
    color: #fff;
    font-size: 16px;
    border-radius: 4px;
    text-align: center;
    width: 72px;
    height: 40px;
    display: inline-block;
    margin-left: 16px;
    vertical-align: middle;
  }
  .btn_shibie_disable{
    background: #eee;
    color: #fff;
    font-size: 16px;
    border-radius: 4px;
    text-align: center;
    width: 72px;
    height: 40px;
    display: inline-block;
    margin-left: 16px;
    vertical-align: middle;
  }
  .search-listBox{
    position: relative;
  }
  .search-list {
    width: 500px;
    background: #fff;
    position: absolute;
    top: 54px;
    z-index: 200 !important;
    max-height: 300px;
    overflow-y: scroll;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.08);
    li {
      border-bottom: 1px solid #eee;
      margin-left: 12px;
    }

    .name {
      font-size: 16px;
    }

    .address {
      font-size: 14px;
    }
  }
}
</style>
